<template>
  <main>
    <div
      class="
        container
        min-vh-100
        d-flex
        justify-content-center
        align-items-center
      "
    >
      <div class="row justify-content-center">
        <div
          class="
            col-sm-11 col-md-9 col-lg-8
            bg-white
            rounded
            shadow
            z-depth-1
            my-2
            wow
            fadeIn
            p-0
          "
        >
          <div class="row">
            <!-- کادر رنگی سمت راست -->
            <div
              class="
                col-3
                bg-dark
                d-flex
                flex-column
                justify-content-between
                align-items-center
                rounded-right
                shadow
                z-depth-1
                p-0
                py-3
              "
            >
              <!-- لوگو و نام نرم افزار -->
              <div class="row">
                <div class="col text-center p-0">
                  <img
                    class="img-fluid px-4"
                    :src="ImageUrl + 'LogoSite.png'"
                    alt="LogoSite"
                  />
                  <span class="text-white" style="font-size: 12px"
                    >سامانه مالی پرش</span
                  >
                </div>
              </div>

              <!-- نگارش و امضاء -->
              <div class="row">
                <div class="col text-center p-0">
                  <span class="text-white d-block"
                    >نگارش : {{ getVersionApp }}</span
                  >
                  <span class="text-white d-block mt-2">پارس رایانه شاپرک</span>
                </div>
              </div>
            </div>

            <!-- مرکز فرم ورود -->
            <div class="col-9 p-4 p-md-5 d-flex flex-column text-right">
              <h4 class="mb-2"><strong>ورود به سامانه</strong></h4>
              <div class="form">
                <div class="my-3 text-dark">
                  <div class="mb-2 d-flex justify-content-between aling-items-center">
                    <strong><i class="fa fa-user ml-1"></i> کد ملی</strong>
                    <a
                      v-if="false"
                      v-on:click="LoginByMobile()"
                      class="
                        m-0
                        h7
                        text-info
                      "
                      title="ورود با تلفن همراه"
                    >
                      <i class="fas fa-sms fa-lg ml-1"></i>
                      ورود با تلفن همراه
                    </a>
                  </div>
                  <input
                    v-model="nationalid"
                    type="text"
                    class="form-control text-center"
                    :class="{ invalid: $v.nationalid.$error }"
                    v-on:input="$v.nationalid.$touch()"
                    v-on:focus="$event.target.select()"
                    placeholder="کد ملی خود را ثبت نمایید"
                  />
                  <p
                    class="text-danger text-center mt-2 h7"
                    v-if="!$v.nationalid.required && $v.nationalid.$dirty"
                  >
                    لطفا کد ملی خود را ثبت نمایید .
                  </p>
                  <p
                    class="text-danger text-center mt-2 h7"
                    v-if="!$v.nationalid.numeric"
                  >
                    کد ملی را باید به صورت عددی ثبت نمایید .
                  </p>
                </div>
                <div class="my-3">
                  <div class="mb-2 text-dark">
                    <strong><i class="fa fa-key ml-1"></i> رمز ورود</strong>
                  </div>
                  <input
                    v-model="password"
                    type="password"
                    class="form-control text-center"
                    :class="{ invalid: $v.password.$error }"
                    v-on:input="$v.password.$touch()"
                    v-on:focus="$event.target.select()"
                    placeholder="رمز ورود خود را ثبت نمایید"
                  />
                  <p
                    class="text-danger text-center mt-2 h7"
                    v-if="!$v.password.required && $v.password.$dirty"
                  >
                    لطفا کلمه عبور را ثبت نمایید .
                  </p>
                  <p
                    class="text-danger text-center mt-2 h7"
                    v-if="!$v.password.minLength"
                  >
                    کلمه عبور باید حداقل
                    {{ $v.password.$params.minLength.min }} کاراکتر داشته باشد .
                  </p>
                </div>
                <div class="text-center">
                  <img
                    class="rounded"
                    style="
                      border: 1px solid #ced4da;
                      border-radius: 5px !important;
                      width: 150px;
                      height: 50px;
                    "
                    :src="captchaImage"
                    alt="captcha"
                  />
                </div>
                <div class="my-3">
                  <div class="mb-2 text-dark">
                    <strong><i class="fa fa-lock ml-1"></i> کد امنیتی</strong>
                  </div>
                  <div class="input-group">
                    <input
                      id="captchatext"
                      v-model="captchatext"
                      type="text"
                      class="form-control text-center rounded-0"
                      :class="{ invalid: $v.captchatext.$error }"
                      v-on:input="$v.captchatext.$touch()"
                      v-on:focus="$event.target.select()"
                      placeholder="کد امنیتی موجود در تصویر بالا را وارد نمایید"
                      v-on:keyup.enter="LoginUser()"
                      style="direction: ltr"
                    />
                    <div class="input-group-prepend rounded-0">
                      <span class="input-group-text">
                        <a v-on:click="getCaptchaImage()">
                          <i class="fas fa-sync"></i>
                        </a>
                      </span>
                    </div>
                  </div>
                </div>
                <p
                  class="h7 text-danger text-center p-0 m-0 mt-2 "
                  v-if="!$v.captchatext.required && $v.captchatext.$dirty"
                >
                  لطفا کد امنیتی را ثبت نمایید .
                </p>
                <div 
                  class="d-flex flex-row justify-content-start align-items-center"
                  v-bind:style="errorText === '' ? 'display: none !important;': ''"
                >
                  <i
                    v-if="errorText != ''"
                    class="fas fa-exclamation-triangle fa-1x-half text-danger"
                  ></i>
                  <span class="h6 red-text mr-2" style="white-space: pre-line; line-height: 25px; min-height: 66px; margin: 0;">
                    {{ errorText }}
                  </span>
                </div>
                <div class="d-flex justify-content-between align-items-center" v-bind:class="errorText === '' ? 'mt-5' : 'mt-2'">
                  <div
                    class="
                      d-inline-flex
                      justify-content-end
                    "
                  >
                    <a
                      v-on:click="RecoveryPassword()"
                      class="
                        m-0
                        h7
                        text-secondary
                      "
                      title="بازیابی رمز ورود"
                    >
                      <i class="fas fa-share-square fa-rotate-180 fa-lg ml-1"></i>
                      رمز ورود را فراموش کرده اید ؟!
                    </a>
                  </div>
                  <div
                    class="
                      d-inline-flex
                      justify-content-end
                      bg-secondary
                      rounded
                      hoverable
                      waves-effect
                    "
                  >
                    <a
                      v-on:click="LoginUser()"
                      class="text-decoration-none px-4 py-2 text-white m-0 h6"
                    >
                      ورود
                    </a>
                    <a
                      v-on:click="LoginUser()"
                      style="background-color: #623879"
                      class="
                        text-decoration-none
                        p-2-half
                        text-white
                        m-0
                        rounded-left
                      "
                    >
                      <i class="fas fa-sign-in-alt fa-rotate-180 fa-lg"></i
                    ></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { newRoutes } from "../../main";
import {
  numeric, // فقط عددی می پذیرد
  integer, // فقط عدد صحیح می پذیرد
  required, // نیاز به اطلاعات غیر خالی دارد
  minValue, // حداقل عددی
  minLength, // حداقل تعداد کاراکتر
} from "vuelidate/lib/validators";

export default {
  data() {
    return {
      nationalid: "",
      password: "",
      captchatext: "",
      errorText: "",
      captchaImage: this.$store.getters.getImageUrl + "wait.gif",
    };
  },
  mounted() {
    this.checkBlockIP();
    this.resetLoginNationalID();
  },
  computed: {
    ImageUrl() {
      // بازیابی آدرس تصاویر
      return this.$store.getters.getImageUrl;
    },
    checkErrorText() {
      // بازیابی خطای لاگین
      return this.$store.getters.getLoginError;
    },
    getVersionApp() {
      return this.$store.getters.getVersionApp;
    },
  },
  created() {
    this.getCaptchaImage();
  },
  methods: {
    // خالی کردن مقدار کد ملی کاربر در حال لاگین
    resetLoginNationalID(){
      this.$store.commit('setLoginNationalID', '');
    },
    // کنترل وضعیت مسدود شدن آی پی کاربر
    async checkBlockIP(){
      // حذف آیتم های به جامانده از مودال بوت استرپ
      // وقتی مودال باز است و داشبورد تایم اوت می شود بقایای مودال جا می ماند
      const elements = document.getElementsByClassName("modal-backdrop");
      while (elements.length > 0) elements[0].remove();

      // حذف بقایای به جامانده از هشدارهای مدیر
      // وقتی هشدارهای مدیر در حال نمایش است و داشبورد تایم اوت می شود هشدارهای باقی می ماند
      if ($('#divAlertAdmin').length != 0 ) $('#divAlertAdmin').remove();

      // بررسی وضعیت مسدود شدن آی پی در سرور
      var blnBlock = await this.$store.dispatch("checkBlockIP");
      if(blnBlock == true){
        // آی پی کاربر مسدود شده است - هدایت به صفحه انتظار
        newRoutes.push("BlockIP");
      }
    },
    // دریافت تصویر کپچا از سرور
    async getCaptchaImage() {
      var str = await this.$store.dispatch("GetCaptchaImage");
      if (str != null) this.captchaImage = str.toString();
      else {
        this.captchaImage = this.$store.getters.getImageUrl + "wait.gif";
        this.$store.dispatch("notify", {
          notText:
            "عدم دریافت تصویر امنیتی\nلطفا مجدد تلاش نمایید !",
          timeOut: 2500,
        });
      }
    },
    async LoginUser() {
      if (!this.$v.$invalid) {
        // ایجاد آبجکت جهت ارسال به سرور
        const user = {
          NationalID: this.nationalid,
          Password: this.password,
          Captcha: this.captchatext,
          CaptchaHash: this.$store.getters.getCaptchaHash,
        };

        this.$store.dispatch("notify", {
          notText: "در حال اتصال به سرور ...",
          timeOut: 2500,
        });
        // ارسال مقادیر به سمت سرور
        await this.$store.dispatch("LoginPart1_SendAcceptCode", user);
      } else {
        this.errorText = " ثبت تمام موارد الزامی است .";
      }
    },
    // بازیابی رمز ورود
    RecoveryPassword(){
      newRoutes.push("RecoveryPassword");
    },
    LoginByMobile(){
      newRoutes.push("LoginByMobile");
    },
    hideError() {
      if (
        this.nationalid != "" &&
        this.password != "" &&
        this.captchatext != ""
      ) {
        this.errorText = "";
      }
    },
  },
  watch: {
    nationalid: function () {
      this.hideError();
    },
    password: function () {
      this.hideError();
    },
    captchatext: function () {
      this.hideError();
    },
    checkErrorText() {
      // تحت نظر گرفتن متغییر مربوط به خطای لاگین
      this.errorText = this.$store.getters.getLoginError;
      if (this.errorText != "") {
        this.captchatext = "";
        this.getCaptchaImage();
      }
    },
  },
  validations: {
    nationalid: {
      required,
      numeric,
    },
    password: {
      required,
      // طبق الزام افتا حداقل رمز ورود باید 8 کاراکتر باشد
      minLength: minLength(8),
    },
    captchatext: {
      required,
    },
  },
  // beforeRouteLeave (to, from, next) {
  //   قبل از تغییر روت اجرا می شود
  //   console.log('Login to: ----------');
  //   console.log(to);
  //   console.log('Login from: ----------');
  //   console.log(from);
  //   next();
  // }
};
</script>

<style>
.invalid {
  border: 1px solid red !important;
  /* box-shadow: 0 0 1px red !important; */
  background-color: rgb(255, 248, 148) !important;
}
</style>


// WEBPACK FOOTER //
// src/pages/Login/Login.vue